import { version, config } from '../../package.json';

export const Environments = {
    // eslint-disable-next-line no-restricted-globals
    ApiUrl: `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}/api/api/`,
    // ApiUrl: `http://localhost:3333/api/`,
    title: `Pre-clinical Trials | v${version} (BUILD ${config.buildVersion})`
}

